export const environment = {
	production: true,
	api_url: 'https://bzai-api2.biztoryapp.com/',
	docker: 0,
	ms: {
		sso: 'sso-ms',
		sale: 'sale-ms',
		user: 'user-ms',
		report: 'report-ms',
		account: 'account-ms',
	},
	docker_api_url: {
		sso: 'http://localhost:5000/',
	},
	subdomain: 'biztory.com.my',
	new_api_url: 'https://bzapi-beta.biztoryapp.com/',
};

export const baseTranslateUrl = '/assets/i18n';

export const redirect_url = '.biztory.com.my';

export const base_url = 'https://';

export const facebook = {
	version: 'v10.0',
};

export const s3Asset = 'https://cdn.biztoryapp.com/staging/bzai/v2/assets';

export const GQLUrl = {
	// add more micro services here
	sso: `${environment.new_api_url}api/sso-ms/graphql`,
};

export const facebookProvider = '604612013032858';

export const googleProvider = '85806127863-6bf6of3dpkfqh1sio5197evdilp8nr4g.apps.googleusercontent.com';

export const consolidateURL = 'https://consolidate.biztoryapp.com';

export const subdomain = undefined;
export const API_URL = 'https://bzai-api2-staging.biztoryapp.com';
export const NEW_API_URL = 'https://bzapi-beta.biztoryapp.com';
export const MICRO_SERVICES = [
	'sso-ms',
	'invoice-ms', // invoice-ms
	'user-ms',
	'report-ms',
	'account-ms',
	'util-ms',
	'third-party-ms',
	'template',
	'transaction-ms',
	'inventory-ms',
] as const;
export const MICRO_SERVICES_ENDPOINT = [
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	NEW_API_URL,
	API_URL,
	NEW_API_URL,
	NEW_API_URL,
] as const;
